import React from 'react';
import sidekick from '@last-rev/contentful-sidekick-util';
import SVG from 'react-inlinesvg';
import isEmpty from 'lodash/isEmpty';
import cx from 'clsx';
import Image from 'next/image';
import styles from './Asset.module.scss';
import AssetPropTypes from './AssetPropTypes';
import imageLoader from './imageLoader';

function Asset({
  _id,
  /* filename, */
  /* size, */
  height,
  title,
  description,
  url,
  width,
  fieldName,
  imageWrapClassName,
  imageClassName,
  isInlineSvg,
  preload,
  bypassOptimization,
  pageSearch,
  isMobile
}) {
  let alt;

  if (!isEmpty(description)) {
    alt = description;
  } else if (!isEmpty(title)) {
    alt = title;
  } else alt = '';

  let imgTitle = null;
  if (!isEmpty(title)) {
    imgTitle = title;
  } else if (!isEmpty(description)) {
    imgTitle = description;
  } else imgTitle = url;

  const showSvg = isInlineSvg !== null ? isInlineSvg : url && url.includes('.svg');

  return (
    <div
      data-testid="Asset"
      className={cx(
        showSvg ? 'inline-svg' : null,
        styles.imageWrap,
        styles[imageWrapClassName],
        imageWrapClassName
      )}
      {...sidekick(_id, fieldName, null, `${showSvg ? 'Inline SVG' : 'Image'}: ${imgTitle}`)}>
       {showSvg ? (
        isMobile ?
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" fill="#0061FE" />
            <path d="M16.3877 12L8.77612 16.7812L16.3877 21.5625L24.0007 16.7812L31.6123 21.5625L39.2239 16.7812L31.6123 12L24.0007 16.7812L16.3877 12Z" fill="#F7F5F2" />
            <path d="M16.3877 31.1251L8.77612 26.3438L16.3877 21.5625L24.0007 26.3438L16.3877 31.1251Z" fill="#F7F5F2" />
            <path d="M24.0007 26.3438L31.6123 21.5625L39.2239 26.3438L31.6123 31.1251L24.0007 26.3438Z" fill="#F7F5F2" />
            <path d="M24.0007 37.5L16.3877 32.7188L24.0007 27.9375L31.6123 32.7188L24.0007 37.5Z" fill="#F7F5F2" />
          </svg> : <SVG
            data-testid="AssetSvg"
            src={url}
            title={alt}
            className={cx(styles.image, styles[imageClassName], imageClassName)}
            focusable="false"
            aria-label={alt}
            uniquifyIDs
          />
      )  : bypassOptimization ? (
        <img src={url} className={cx(styles.image, styles[imageClassName], imageClassName)} alt={alt} />
      ) : (
         <div  style={!pageSearch?{ maxHeight: height, maxWidth: width, margin: '0 auto', height:'100%'}:{width:"85px", height:"85px",margin:"auto"}}>
          <Image
            width={width}
            height={height}
            className={cx(styles.image, styles[imageClassName], imageClassName)}
            alt={alt}
            priority={preload}
            layout="responsive"
            loading={preload ? 'eager' : 'lazy'}
            loader={imageLoader}
            src={url}
          />
        </div>
      )}
    </div>
  );
}

Asset.propTypes = AssetPropTypes;

Asset.defaultProps = {
  _id: null,
  fieldName: '',
  imageWrapClassName: null,
  imageClassName: 'imgFluid',
  filename: '',
  height: 0,
  width: 0,
  size: 0,
  isInlineSvg: null,
  title: '',
  description: '',
  preload: false,
  bypassOptimization: false
};

export default Asset;